<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Books</li>
                <li></li>
            </ul>
            <h2 i18n>List of Books</h2>
        </div>
    </div>
</div>

<div class="blog-area ptb-100" [class.dark-blog-area]="themeService.isDark()">
    <div class="container">
        <div class="row pb-5">
            <h3 i18n>All Books</h3>
            <div class="woocommerce-topbar">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="topbar-ordering-and-search">
                            <div class="row align-items-center">
                                <form [formGroup]="filter_form" (submit)="applyFilter()">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12">
                                            <div class="billing-details">
                                                <div class="row">
                                                    <div class="col-lg-6 col-md-6">
                                                        <div class="form-group">
                                                            <label i18n>Language</label>
                                                            <div class="select-box">
                                                                <select formControlName="content_language"
                                                                    class="form-select">
                                                                    <option *ngFor="let lang of languages"
                                                                        [value]="lang.id">{{lang.value}}</option>

                                                                </select>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6">
                                                        <div class="form-group">
                                                            <label i18n>Book Category</label>
                                                            <div class="select-box">
                                                                <select formControlName="book_category"
                                                                    class="form-select">
                                                                    <option *ngFor="let art of book_categories"
                                                                        [value]="art.id">{{art.category_name}}</option>
                                                                </select>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4 col-md-4 pt-3">
                                                        <div class="form-group">
                                                            <label i18n>Title</label>
                                                            <input type="text" formControlName="title"
                                                                class="form-control">

                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4 col-md-4 pt-3">
                                                        <div class="form-group">
                                                            <label i18n>Author</label>
                                                            <input type="text" formControlName="authors"
                                                                class="form-control">

                                                        </div>
                                                    </div>

                                                    <div class="col-lg-4 pt-3">
                                                        <div class="form-group">
                                                            <label>&nbsp;<span></span></label>
                                                            <button type="submit" value="Filter" class="default-btn">
                                                                <i class='bx bx-filter-alt icon-arrow before'></i><span
                                                                    class="label" i18n>Filter</span><i
                                                                    class="bx bx-filter-alt icon-arrow after"></i>
                                                            </button>
                                                            &nbsp; &nbsp;
                                                            <a (click)="resetFilter()" class="back-btn">
                                                                <i class='bx bx-reset icon-arrow before'></i><span
                                                                    class="label" i18n>Reset</span><i
                                                                    class="bx bx-reset icon-arrow after"></i>
                                                            </a>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let book of books">
                <div class="single-blog-post mb-30">
                    <div class="post-image">
                        <a routerLink="/books/{{book.id}}" class="d-block">
                            <img [src]="imageUrl + book.image" style="height:20em" alt="image">
                        </a>
                        <div class="tag">
                            <a>{{book.related_category.category_name}}</a>
                        </div>
                    </div>
                    <div class="post-content">
                        <ul class="post-meta">
                            <li class="post-author">
                                <span i18n>By: </span><a class="d-inline-block">{{book.authors}}</a>
                            </li>
                            <li><a>{{book.published_date| date :'longDate'}}</a></li>
                        </ul>
                        <h3><a routerLink="/books/{{book.id}}" class="d-inline-block">{{book.title}}</a></h3>
                        <a routerLink="/books/{{book.id}}" class="read-more-btn" i18n>Read More <i
                                class='bx bx-right-arrow-alt'></i></a>
                    </div>
                </div>
            </div>


            <div class="col-lg-12 col-md-12 col-sm-12">
                <app-pagination [currentPage]="currentPage" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems"
                    (pageChanged)="onPageChange($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>